<template>
  <div :class="['column', isSizeDesk, isOffSetDesk, isSizeTab, isOffSetTab, 'with-elevation']">
    <div :class="['columns', isReversed && 'reverse-columns']">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Elevation',
  props: {
    deskSize: Number,
    tabSize: Number,
    isReversed: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isSizeDesk() {
      return this.deskSize ? `is-${this.deskSize}-desktop` : '';
    },
    isOffSetDesk() {
      return this.deskSize ? `is-offset-${(12 - this.deskSize) / 2}-desktop` : '';
    },
    isSizeTab() {
      return this.tabSize ? `is-${this.tabSize}-tablet` : '';
    },
    isOffSetTab() {
      return this.tabSize ? `is-offset-${(12 - this.tabSize) / 2}-tablet` : '';
    }
  }
};
</script>
